// Ruutujen muotojen (maksimineliö, klusteri) tekstit käyttöliittymälle.
// Luvut tulevat palvelimelta (backend/app/shapes.py); tässä vain muotoilu.

const fi = (n, digits = 1) => n.toLocaleString("fi-FI", { maximumFractionDigits: digits });

/** "7 × 7" */
export const squareLabel = (sq) => `${sq.size} × ${sq.size}`;

/** Neliön koko maastossa: "noin 1,1 × 1,0 km" tai "noin 850 × 840 m". */
export function sizeText(sq) {
  const big = Math.max(sq.width_m, sq.height_m) >= 1000;
  const f = (m) => (big ? fi(m / 1000) : fi(Math.round(m / 10) * 10, 0));
  return `noin ${f(sq.width_m)} × ${f(sq.height_m)} ${big ? "km" : "m"}`;
}

/** Montako ruutua puuttuu: "vielä 9 ruutua" / "vielä 1 ruutu". */
export const missingText = (n) => `vielä ${n} ${n === 1 ? "ruutu" : "ruutua"}`;

/** Kulkutapasuodatuksen selite: "Pyöräily" tai "Kävely ja juoksu" tai "3 kulkutapaa". */
export function modesText(modes, labelOf) {
  if (!modes.length) return "Kaikki kulkutavat";
  if (modes.length <= 2) return modes.map((m) => labelOf(m).toLowerCase()).join(" ja ").replace(/^./, (c) => c.toUpperCase());
  return `${modes.length} kulkutapaa`;
}
